import { BaseProfilEcriture, Gabarit } from '@mairistem/finances-utils';
import {
  LigneMouvement,
  Mouvement,
  ParametreGeneralEntite,
  Sens,
} from '@mairistem/comptabilite';
import { isEmpty } from 'lodash';
import { ErrorField } from '@mairistem/liste';
import Imputation from '../Imputation';
import PiecePanel from '../../../../interfaces/pieces/mouvements/piecePanel';
import { MODE_REGLEMENT, ModeReglementType } from '../../../../constants/mouvements/modeReglements';
import { ASAP } from '../../../../constants/mouvements/asapOptions';

class BaseProfilEcritureMouvement extends BaseProfilEcriture {
  code = '';

  entite: ParametreGeneralEntite;

  imputation = new Imputation();

  isLiaisonVisible = true;

  modeDeReglement: string[] = [];

  naturePiece: string = '';

  panels: PiecePanel[] = [];

  typeBordereau = '';

  typePiece = '';

  codesProduitLocal: string[] = [];

  /**
   * Fonction permettant de mettre à jour les informations du mouvement dès
   * le changement d'un profil
   * @returns Retourne les attributs par défauts
   */
  onProfilSelect(_data: Partial<Mouvement>) {
    return {
      ...(!isEmpty(this.naturePiece)
        && { naturePiece: this.naturePiece }),
      ...(!isEmpty(this.typePiece)
        && { typePiece: this.typePiece }),
    };
  }

  /**
 * Permet de récupérer le mode de réglement par rapport au sens
 * @returns liste de mode de réglement
 */
  getModeReglement(sens: string) {
    let optionsModeReglement = null;
    if (sens === Sens.DEPENSE) {
      optionsModeReglement = MODE_REGLEMENT.DEPENSE_LIST;
    } else {
      optionsModeReglement = MODE_REGLEMENT.RECETTE_LIST;
    }

    if (!isEmpty(this.modeDeReglement)) {
      optionsModeReglement = optionsModeReglement.filter(
        (mode: ModeReglementType) => this.modeDeReglement.includes(mode.key),
      );
    }

    return optionsModeReglement;
  }

  getLigneDefaultAttributes(): object {
    return {};
  }

  check(_mouvement: Mouvement): ErrorField[] {
    const errors: ErrorField[] = [];

    _mouvement?.lignes?.forEach((ligne: any) => {
      errors.push(...this.checkLigne(ligne));
    });

    return errors;
  }

  checkLigne(_ligne: LigneMouvement): ErrorField[] {
    return [];
  }

  // #region panelDefaultAttributes
  getAsapEditionDefaultAttributes(
    isTiersMulti: boolean,
    piece: Mouvement,
    isChangedTiers?: boolean,
  ) {
    let value = ASAP.A_EDITER;

    if (isTiersMulti) {
      value = ASAP.NON_DEMATERIALISEE;
    } else if (isEmpty(piece?.tiers?.categoriePes)) {
      value = ASAP.COMPTABLE;
    } else if (piece?.tiers?.categoriePes?.startsWith('2')) {
      value = ASAP.CHORUS_PRO;
    }

    return {
      asapEdition: value,
      ...((isChangedTiers
        || value !== ASAP.CHORUS_PRO)
        && { asapNumeroEngagement: null }),
      ...(isEmpty(piece?.asapCodeService) && {
        asapCodeService: (value !== ASAP.CHORUS_PRO) ? null : 'FACTURE_PUBLIQUE',
      }),
    };
  }

  getDetailDeFacturationDefaultAttributes(piece: Mouvement) {
    return {
      lfacLibelle: piece?.objetPiece?.substring(0, 199),
      lfacDate: piece?.dateDepartDelaiGlobalPaiement,
    };
  }

  getPeriodeCouverteDefaultAttributes(annee: number) {
    return {
      dateDebutCharge: `${annee}-01-01`,
      dateFinCharge: `${annee}-12-31`,
    };
  }

  // #endregion
  getNaturesGabarit(_gabaritsPj: Gabarit[]) {
    return [];
  }
}

export default BaseProfilEcritureMouvement;
